<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M27.3887 3.05556C27.9813 3.16667 28.4627 3.46297 28.8331 3.94445C29.2035 4.38889 29.3887 4.92593 29.3887 5.55556C29.3887 8.88889 28.722 12.0926 27.3887 15.1667C26.0924 18.2037 24.3331 20.8333 22.1109 23.0556C19.9257 25.2407 17.3146 26.9815 14.2776 28.2778C11.2405 29.5741 8.03682 30.2222 4.66645 30.2222C4.07386 30.2222 3.53682 30.037 3.05534 29.6667C2.6109 29.2963 2.33312 28.8148 2.22201 28.2222L0.999784 23C0.851636 22.4074 0.907191 21.8333 1.16645 21.2778C1.46275 20.7222 1.90719 20.3333 2.49978 20.1111L8.1109 17.6667C8.62941 17.4444 9.16645 17.4074 9.72201 17.5556C10.2776 17.7037 10.7405 18 11.1109 18.4444L12.8887 20.6667C15.8887 19.037 18.2035 16.7222 19.8331 13.7222L17.6109 11.9444C17.1665 11.5741 16.8702 11.1111 16.722 10.5556C16.6109 10 16.6479 9.46297 16.8331 8.94445L19.2776 3.33334C19.5368 2.74075 19.9257 2.31482 20.4442 2.05556C20.9998 1.75926 21.5739 1.68519 22.1665 1.83334L27.3887 3.05556ZM4.77756 27.5556C8.74052 27.5556 12.4072 26.5741 15.7776 24.6111C19.1479 22.6482 21.8146 19.9815 23.7776 16.6111C25.7405 13.2407 26.722 9.57408 26.722 5.61112L21.6665 4.44445L19.3331 9.94445L23.1109 13C21.8516 15.7407 20.3887 17.9259 18.722 19.5556C17.0924 21.1852 14.9072 22.6482 12.1665 23.9444L9.1109 20.1667L3.6109 22.5L4.77756 27.5556Z" fill="black"/>
  </svg>
</template>

<script setup>
  defineOptions({
    name: 'SupportPhoneIcon',
  });
</script>

